import React from "react";
import dentalImg from "../../assets/Images/tooth-polishing_bdb84_lg.jpg"
import { useDispatch, useSelector } from 'react-redux'  
import { assignLanguage } from "../../utils/helpers";
const DentalServiceComponent = (props) => {
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = assignLanguage(language?.language)
    return (
        <div className="main">
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={dentalImg} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <h2>
                        {selectedLanguage?.scaling_and_polishing_heading}
                    </h2>
                    <h3>{selectedLanguage?.tooth_scaling_heading}</h3>
                    <p>
                        {selectedLanguage?.toothe_scaling_paragraph}
                    </p>
                    <h3>
                        {selectedLanguage?.tooth_polishing_heading}
                    </h3>
                    <p>
                        {selectedLanguage?.tooth_polishing_one_paragraph}
                    </p>
                    <p>
                        {selectedLanguage?.tooth_polishing_paragraph_two}
                    </p>
                </div>
            </div>
        </div>
    )
}
export default DentalServiceComponent